import { fg } from '@confluence/feature-gating';

/**
 * Whether any meeting-signal consumer needs page content to be analysed.
 *
 * GAS v3 controls instrumentation, while the HT and LT gates control the two
 * nudge audiences. Keeping this check shared prevents callers from converting
 * ADF when every consumer is disabled.
 */
export const isMeetingSignalAnalysisEnabled = (): boolean =>
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	fg('twcg-2202-gasv3') ||
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	fg('twcg-2202-loom-meeting-nudge-ht-gate') ||
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	fg('twcg-2202-loom-meeting-nudge-lt-gate');
